module.exports = __webpack_public_path__ + "img/mq.c63edc99.svg";